import { Stack, Typography } from "@mui/material";
import { ReuseModal } from "../../ReuseModal";
import { PermissionsItems } from "./PermissionsItems";
import { useState } from "react";
import { PermissionRoleMapper } from "../../../company";
import {
  PermissionItem,
  RolePermissionType,
  UserThatShareCampaign,
} from "../../../../types/apiTypes";
import { PermissionRoles } from "../../../../types/enums";

type Props = {
  user: UserThatShareCampaign;
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onSuccess: (updatedUser: UserThatShareCampaign) => void;
  isShare?: boolean;
  role: PermissionRoles;
};

export const ManagePermissionsModal = ({
  user,
  isOpen,
  isLoading,
  onClose,
  onSuccess,
  isShare = false,
  role,
}: Props) => {
  const { first_name, last_name } = user;
  const [openAccordion, setOpenAccordion] = useState<string>("view");
  const [permissions, setPermissions] = useState<RolePermissionType>(
    user.permissions,
  );

  const openAccordionHandler = (title: string) => {
    setOpenAccordion(openAccordion === title ? "" : title);
  };

  const changePermissionsHandler = (title: string, permission: string) => {
    setPermissions((prev) => {
      const topic = prev[title as keyof RolePermissionType];
      const subTopic = topic[
        permission as keyof typeof topic
      ] as PermissionItem;

      if (!topic || !subTopic) {
        return prev;
      }

      return {
        ...prev,
        [title]: {
          ...topic,
          [permission]: {
            ...subTopic,
            allowed: !subTopic.allowed,
          },
        },
      };
    });
  };

  const updatePermissionHandler = () => {
    onSuccess({ ...user, permissions });
  };

  const isPermissionsChanged =
    JSON.stringify(user.permissions) === JSON.stringify(permissions);

  return (
    <ReuseModal
      isOpen={isOpen}
      onClose={onClose}
      title={"Manage Permissions"}
      onSubmit={updatePermissionHandler}
      maxWidth="540px"
      submitBtnColor="#1C3C6C"
      submitBtnText={isShare ? "Save & Return to Share" : "Save"}
      cancelBtnText={isShare ? "Back to Share" : "Cancel"}
      isDisabledCancelBtn={isLoading}
      isDisabled={isLoading || isPermissionsChanged}
    >
      <Stack gap={"24px"} paddingBottom={"16px"}>
        <Stack flexDirection={"row"} gap={"16px"} alignItems={"center"}>
          <Typography
            component="span"
            variant="subtitle1"
            color="custom.textDarkBlue"
            fontWeight={500}
          >
            {`${first_name} ${last_name}`}
          </Typography>
          <PermissionRoleMapper role={role} />
        </Stack>
        <Stack gap={"16px"} maxHeight={"480px"} overflow={"auto"}>
          {Object.entries(permissions).map(([title, item]) => (
            <PermissionsItems
              key={title}
              title={title}
              permissions={item}
              isExpanded={title === openAccordion}
              onExpandedHandler={openAccordionHandler}
              changePermissionsHandler={changePermissionsHandler}
            />
          ))}
        </Stack>
      </Stack>
    </ReuseModal>
  );
};
